<template>
    <div>
      <v-dialog name="dialog" />
      <Quiz v-if="asyncFlag" :question="question" :cnt="questionSet.length" @switch-question="saveAndGetSingleQuestion"></Quiz>
  </div>
</template>

<script>
    import Quiz from '@/page/modules/exam/quiz'
    import utils from '@/utils'
    export default {
        name: "quizContainer",
        components: { Quiz },
        props: ['params'],
        data () {
          return {
            asyncFlag: false,
            outputs: [],
            question: {}, // 当前的题目对象
            questionSet: [], // 题组的所有题目
            examData: {}, // 题组自己的对象
            examId: '', // 生成的examId
            answerParams: { // 需要提交的答案对象
              id: '',
              examId: '',
              paperId: this.params.inputs.paperId,
              isFinish: '0',
              questionId: '',
              answer: '',
              mark: '',
              examStart: ''
            }
          }
        },
        mounted () {
          this.initData()
        },
        methods: {
          confirmBox (o) {
            this.$modal.show('dialog', {
              title: o.title,
              text: o.text,
              buttons: [
                {
                  title: '确认',
                  default: true,
                  handler: utils.debounce(() => {
                    if (o.yes && o.yes instanceof Function) {
                      o.yes()
                    }
                  }, 1000)
                },
                {
                  title: '取消'
                }
              ]
            })
          },
          createExamId (paperId) { // 生成examId
            var that = this
            return new Promise(function (resolve, reject) {
              that.$api.post(that.$global.examApiPath, '/examExamScore/getExamId', {paperId: paperId}, r => {
                resolve(r.data)
              })
            })
          },
          saveQuizRecord (item) {
            var that = this
            return new Promise(function (resolve, reject) {
              that.$api.post(that.$global.bylApiPath, '/exam/add', item, r => {
                resolve(r.data)
              })
            })
          },
          getExamBy (examId, paperId) {
            var that = this
            return new Promise(function (resolve, reject) {
              that.$api.post(that.$global.examApiPath, '/examPaper/getByExam', {examId: examId, id: paperId}, r => {
                resolve(r.data)
              })
            })
          },
          getQuestionsBy (examId) {
            var that = this
            return new Promise(function (resolve, reject) {
              that.$api.post(that.$global.examApiPath, '/examExamScoreInfo/search', {examId: examId}, r => {
                resolve(r.data)
              })
            })
          },
          getSingleQuestionBy (infoId, getAnswer) {
            var that = this
            return new Promise(function (resolve, reject) {
              that.$api.post(that.$global.examApiPath, '/examQuestion/getByExam', {infoId: infoId, getAnswer: getAnswer}, r => {
                resolve(r.data)
              })
            })
          },
          saveAnswersBy (answers) {
            var that = this
            return new Promise(function (resolve, reject) {
              that.$api.post(that.$global.examApiPath, '/examExamScoreInfo/save', answers, r => {
                resolve(r.data)
              })
            })
          },
          saveAndGetSingleQuestion (o) {
            this.answerParams.examId = this.examId
            this.answerParams.answer = o.answer
            this.answerParams.id = o.currentQ.infoId
            this.answerParams.questionId = o.currentQ.id
            this.answerParams.isFinish = o.isFinish
            if(this.answerParams.answer == 'no_answer_result'){
              this.$modal.show('dialog', {
                title: '提示',
                text: '请选择或填写题目答案！',
                buttons: [
                  {
                    title: '确定',
                    default: true,
                    handler: () => {
                      this.$modal.hide('dialog')
                    }
                  }
                ]
              })
            }else{
              var that = this
              if (o.isFinish == '1') {
                this.confirmBox({
                  title: '提交',
                  text: '确认提交吗?',
                  yes: function () {
                    that.submit(o)
                    that.$modal.hide('dialog')
                  }
                })
              } else {
                that.submit(o)
              }
            }
          },
          submit (o) {
            this.saveAnswersBy(this.answerParams).then((res) => {
              if (o.isFinish == '0') {
                this.getSingleQuestionBy(this.questionSet[o.nextIdx].id, '0').then((res) => { // 切到下一题
                  this.question = res
                })
              } else { // 测验完成,获取结果,并保存到课程章节的结果中
                this.getExamResultBy(this.examId).then((res) => {
                  let obj = {
                    chapterId: this.params.inputs.chapterId,
                    courseId: this.params.inputs.courseId,
                    examId: this.examId,
                    total: res.paperScore,
                    grade: res.score,
                    pass: res.isPassed
                  }
                  this.saveQuizRecord(obj).then((r)=>{
                    this.$modal.show('dialog', {
                      title: '提示',
                      text: '该课程章节已经结束！',
                      buttons: [
                        {
                          title: '确定',
                          default: true,
                          handler: () => {
                            this.$modal.hide('dialog')
                            this.$parent.cancel() // 调用封装的模态框组件里的方法去关掉模态框
                            this.$router.push({path: '/examResult/' + this.examId}) // 并且调转路由到result页面
                          }
                        }
                      ]
                    })
                  })
                })
              }
            })
          },
          getExamResultBy (examId) {
            var that = this
            return new Promise(function (resolve, reject) {
              that.$api.post(that.$global.examApiPath, '/examExamScore/getPaperResult', {id: examId}, r => {
                resolve(r.data)
              })
            })
          },
          initData () {
            this.createExamId(this.params.inputs.paperId).then((res) => {
              var examId = res
              this.examId = res
              var o = {
                chapterId: this.params.inputs.chapterId,
                courseId: this.params.inputs.courseId,
                examId: examId
              }
              this.getQuestionsBy(examId).then((res) => {
                this.questionSet = res
                this.getSingleQuestionBy(this.questionSet[0].id, '0').then((res) => {
                  this.asyncFlag = true
                  this.question = res
                })
              })
              this.getExamBy(examId, this.params.inputs.paperId).then((res) => {
                this.examData = res
                o.total = this.examData.score
                this.saveQuizRecord(o)
              })
            })
          }
        }
    }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/modules/course/quizContainer.vue